import React from 'react'

const Benefits_WPChatbot = () => {
    const items = [
        {
            title: "Scan & qualify leads 24/7",
            desc: "Auto-capture inquiries, ask smart qualifiers, and route hot leads instantly—no wait, no drop-offs.",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M4 5h16M6 10h12M8 15h8M10 20h4" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
        },
        {
            title: "Resolve routine tickets",
            desc: "Bots handle FAQs, returns, and status checks so agents focus on high-value conversations.",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="4" y="4" width="16" height="12" rx="2" stroke="#7c3aed" strokeWidth="2" />
                    <path d="M8 20h8" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
        },
        {
            title: "Respond & nurture effortlessly",
            desc: "Auto-send rich media guides and follow-ups the moment prospects ask—higher reply rates.",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M4 6h16v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6z" stroke="#0ea5e9" strokeWidth="2" />
                    <path d="M4 8l8 5 8-5" stroke="#0ea5e9" strokeWidth="2" strokeLinecap="round" />
                </svg>
            ),
        },
        {
            title: "Share catalogs & demos",
            desc: "Show products, PDFs, and videos inside chat; send pricing or checkout links instantly.",
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="3" y="3" width="12" height="12" rx="2" stroke="#10b981" strokeWidth="2" />
                    <path d="M14 10h7m-3-3 3 3-3 3" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            ),
        },
    ];

    return (
        <section className="py-4 position-relative benefits-sec" style={{ overflow: 'hidden' }}>
            {/* gradient blobs background */}
            <style>{`
        .benefits-sec{
          position:relative;
          background: #ffffff;
          isolation:isolate; /* keeps pseudo elements behind content */
        }
        .benefits-sec::before,
        .benefits-sec::after{
          content:"";
          position:absolute; inset:0;
          pointer-events:none;
          z-index:0;
        }
        /* top-left baby blue blob */
        .benefits-sec::before{
          background:
            radial-gradient(280px 220px at left -60px top -60px,
              rgba(173,216,230,0.55) 0%,
              rgba(173,216,230,0.28) 40%,
              rgba(173,216,230,0.00) 70%);
          filter: blur(2px);
        }
        /* bottom-right pista green blob */
        .benefits-sec::after{
          background:
            radial-gradient(300px 240px at right -40px bottom -60px,
              rgba(193,255,193,0.55) 0%,
              rgba(193,255,193,0.25) 45%,
              rgba(193,255,193,0.00) 75%);
          filter: blur(2px);
        }

        /* grid + cards */
        .benefits-wrap{ position:relative; z-index:1; }
        .benefits-grid{
          display:grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 26px;
          margin-top: 36px;
        }
        .benefit-card{
          background: rgba(255,255,255,0.88);
          border: 1px solid rgba(15,23,42,0.06);
          border-radius: 14px;
          padding: 22px 22px 24px;
          box-shadow: 0 8px 18px rgba(15,23,42,0.05);
          transition: transform .18s ease, box-shadow .18s ease, background .18s ease, border-color .18s ease;
        }
        /* subtle hover pop like your 2nd reference */
        .benefit-card:hover{
          transform: translateY(-4px);
          background: rgba(255,255,255,0.98);
          border-color: rgba(15,23,42,0.10);
          box-shadow: 0 14px 32px rgba(15,23,42,0.14);
        }
        .benefit-icon{
          width:44px; height:44px; border-radius:10px;
          display:flex; align-items:center; justify-content:center;
          background: #eef2ff; /* light indigo */
          margin-bottom: 14px;
        }
        .benefit-title{
          font-size: 1.25rem;
          line-height: 1.35;
          font-weight: 700;
          color: #0f172a; /* slate-900 */
          margin: 0 0 8px 0;
          font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        }
        .benefit-desc{
          margin:0;
          color:#334155; /* slate-700 */
          line-height:1.6;
          font-size: 0.98rem;
          font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
        }

        /* responsive */
        @media (max-width: 1100px){
          .benefits-grid{ grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 600px){
          .benefits-grid{ grid-template-columns: 1fr; }
        }
      `}</style>

            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative benefits-wrap"
                style={{ maxWidth: '74%', zIndex: 1, marginTop: 60 }}
            >
                {/* Heading */}
                <div style={{ marginTop: '40px', }}>
                    <h2
                        style={{
                            fontSize: '44px',
                            fontFamily: "'Inter'",
                            fontWeight: 650,
                            color: '#242121ff',
                            lineHeight: 1.2,
                        }}
                    >
                        Benefits of using
                        <br /><span style={{ color: '#1DB954' }}> WhatsApp chatbot</span>  platform
                    </h2>
                </div>

                {/* 4 cards */}
                <div className="benefits-grid">
                    {items.map((it, idx) => (
                        <div className="benefit-card" key={idx}>
                            <div className="benefit-icon">{it.icon}</div>
                            <h3 className="benefit-title">{it.title}</h3>
                            <p className="benefit-desc">{it.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Benefits_WPChatbot
